export default __webpack_public_path__ + "static/ableaura-6d69063c20a89a2fbb5e6209a3e1ae19.svg";